<div class="giving-info-dialog">
  <!-- Close/Back button -->
  <button class="close-button" (click)="onClose()" type="button" aria-label="Close">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#96080B"/>
      <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

  <!-- Header section with heading and image -->
  <div class="header">
    <h2 class="heading">{{ data.heading | translateLang }}</h2>

    <!-- Image -->
    <div class="image-container">
      <img [src]="data.imageSrc" [alt]="data.imageAlt || 'Dialog image'" class="image" />
    </div>
  </div>

  <!-- About section -->
  <div class="content-section">
    <h3 class="section-heading">{{ data.aboutHeading | translateLang }}</h3>
    <p class="section-description">{{ data.aboutDescription | translateLang }}</p>
  </div>

  <!-- What We Do section -->
  <div class="content-section">
    <h3 class="section-heading">{{ data.whatWeDoHeading | translateLang }}</h3>
    <p class="section-description">{{ data.whatWeDoDescription | translateLang }}</p>
  </div>

  <!-- Feature cards -->
  <div class="feature-cards">
    @for (feature of data.features; track feature.title) {
      <div class="feature-card">
        <p class="feature-content">
          <span class="feature-title">{{ feature.title | translateLang }}</span>
          <br />
          {{ feature.description | translateLang }}
        </p>
      </div>
    }
  </div>

  <!-- Footer text -->
  <p class="footer-text">{{ data.footerText | translateLang }}</p>
</div>
